<template>
  <div>
    <b-container variant="primary" fluid class="p-5">
      <NewOutgoingPaymentModal
        v-if="showOutgoingPaymentModal"
        @hidden="showOutgoingPaymentModal = false"
        @newOutgoingPayment="processNewOutgoingPayment"
      />
      <b-row>
        <b-col :cols="12">
          <h2>Caja</h2>
          <p v-if="locationInfo">
            La tienda de {{ locationInfo.name }} tiene actualmente
            {{ locationInfo.cash_quantity }} EUR en la caja.
          </p>
          <h3>Histórico de variaciones</h3>
          <v-server-table
            :url="table.url"
            ref="table"
            :columns="table.columns"
            :options="table.options"
          >
            <div slot="afterFilterWrapper" class="form-group form-inline">
              <b-button
                variant="primary"
                @click="showOutgoingPaymentModal = true"
              >
                Nueva salida de caja</b-button
              >
            </div>
            <template v-slot:quantity="props">
              <span
                >{{ props.row.quantity > 0 ? '+' : '' }}{{ props.row.quantity }}
              </span>
            </template>

            <template v-slot:comission_amt="props">
              <span
                >{{
                  props.row.comission_amt > 0 ? props.row.comission_amt : '-'
                }}
              </span>
            </template>

            <template v-slot:abbr_product_name="props">
              {{
                props.row.product
                  ? `${props.row.product.reference} (${props.row.product.id})`
                  : `${props.row.predefined_product.reference} (${props.row.predefined_product.id})`
              }}
            </template>

            <template v-slot:created_at="props">
              <span>{{ props.row.created_at }}</span>
            </template>

            <template v-slot:total_price="props">
              <span>{{ props.row.total_price }} €</span>
            </template>

            <template v-slot:created_by="props">
              <span>{{
                props.row.employee_first_name
                  ? props.row.employee_first_name
                  : '-'
              }}</span>
            </template>

            <template v-slot:orders="props">
              <div :key="order" v-for="order in props.row.order_set">
                <b-link
                  :to="{
                    name: 'AdminOrdersEditScreen',
                    params: { id: order },
                  }"
                  >{{ order }}
                </b-link>
              </div>
            </template>

            <template v-slot:actions="props">
              <b-button-group>
                <b-button
                  :to="{
                    name: 'AdminCashEditScreen',
                    params: { id: props.row.id },
                  }"
                  size="sm"
                  variant="outline-primary"
                  ><b-icon icon="eye-fill" aria-hidden="true" /> /
                  <b-icon icon="pencil" aria-hidden="true" />
                </b-button>
              </b-button-group>
            </template>
          </v-server-table>
          <h3>Comisiones</h3>
          <p>Listado de comisiones pendientes a cobrar por los empleados:</p>
          <b-row>
            <b-col cols="12" sm="12" md="8" lg="6"
              ><v-server-table
                :url="tableComissions.url"
                ref="tableComissions"
                :columns="tableComissions.columns"
                :options="tableComissions.options"
              >
                <template v-slot:pending_comissions_total_amt="props">
                  {{
                    props.row.pending_comissions_total_amt
                      ? props.row.pending_comissions_total_amt + ' EUR'
                      : '-'
                  }}
                </template>
                <template v-slot:actions="props">
                  <b-button-group>
                    <b-button
                      v-if="locationInfo"
                      :disabled="
                        !props.row.pending_comissions_total_amt ||
                        !enoughCashToPay(
                          props.row.pending_comissions_total_amt,
                          locationInfo.cash_quantity
                        )
                      "
                      @click="redeemComission(location, props.row.id)"
                      size="sm"
                      variant="outline-primary"
                      ><b-icon icon="cash-coin" aria-hidden="true" /> Cobrar
                    </b-button>
                    <b-button
                      :to="{
                        name: 'AdminCommissionsScreen',
                        params: { location: location, employee: props.row.id },
                      }"
                      size="sm"
                      variant="outline-primary"
                      ><b-icon icon="eye-fill" aria-hidden="true" /> Ver
                      histórico
                    </b-button>
                  </b-button-group>
                </template>
              </v-server-table></b-col
            >
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import {
  required,
  numeric,
  minValue,
  decimal,
  requiredIf,
} from 'vuelidate/lib/validators';
import ProductModal from '@/admin/components/quotes/ProductModal.vue';
import NewOutgoingPaymentModal from '@/admin/components/cash/NewOutgoingPaymentModal.vue';
import PredefinedProductModal from '@/admin/components/quotes/PredefinedProductModal.vue';

import FreeTextProductModal from '@/admin/components/quotes/FreeTextProductModal.vue';
import SubtitleModal from '@/admin/components/quotes/SubtitleModal.vue';

import AdminCustomersEditScreen from '@/admin/screens/customers/AdminCustomersEditScreen.vue';

import { actions, uris } from '@/admin/api.js';

import store from '@/admin/store.js';
import { validationMixin } from 'vuelidate';

import * as Sentry from '@sentry/browser';
import Multiselect from 'vue-multiselect';

export default {
  name: 'AdminCashEditScreen',
  props: ['location'],

  components: {
    Multiselect,
    ProductModal,
    PredefinedProductModal,
    FreeTextProductModal,
    AdminCustomersEditScreen,
    SubtitleModal,
    NewOutgoingPaymentModal,
  },
  mixins: [validationMixin],
  validations() {
    let rules = {
      customer: {
        required,
      },
      // billingAddress: {
      //   required,
      // },
      shippingMethod: {
        required,
      },
      location: {
        required,
      },
      shippingAddress: {},
      manual_numeration: {},
      productPricesInclTax: {
        required,
      },
      productPricesExclTax: {
        required,
      },
      productDiscounts: {},
      productDiscountsAbsolute: {},
      discountType: {
        required,
      },
      discount: {
        required,
      },
      discountPct: {
        required,
      },
      totalPriceProductsInclTax: {
        required,
      },
      totalPriceProductsExclTax: {
        required,
      },
      shippingPrice: {
        required,
      },
      taxPrice: {
        required,
      },
      amtPaid: {
        required,
      },
      amtPaidCredit: {
        required,
      },
      amtPaidTransfer: {
        required,
      },
      amtPaidCash: {
        required,
      },
      products: {
        $each: {
          reference: {
            required,
          },
          attributes: {
            $each: {
              selector_inputs: {
                required,
              },
              extra_info: {},
              label: {
                required,
              },
              reference: {
                // Empty for predefined products
              },
            },
          },
          description: {},
          comments: {},
          subtitle: {},
          images: {
            $each: {},
          },
          quantity: {
            required,
          },
          type: {
            required,
          },
        },
      },
    };

    return {
      form: rules,
    };
  },
  data() {
    return {
      sharedState: store.state,
      showOutgoingPaymentModal: false,
      table: {
        url: uris.cashByLocationURI(this.location),
        selected: [],
        allSelected: false,
        columns: ['description', 'quantity', 'created_at'],
        options: {
          filterable: false,
          sortable: [],
          headings: {
            abbr_product_name: 'Producto',
            quantity: 'Variación',
            description: 'Descripción',
            created_at: 'Fecha',
          },
        },
      },
      tableComissions: {
        url: uris.cashPendingSalesComissionByLocationURI(this.location),
        selected: [],
        allSelected: false,
        columns: [
          'get_full_name',
          'sales_comission_pct',
          'pending_comissions_total_amt',
          'actions',
        ],
        options: {
          texts: {
            count: '',
          },

          filterable: false,
          sortable: [],
          headings: {
            abbr_product_name: 'Producto',
            quantity: 'Variación',
            description: 'Descripción',
            created_at: 'Fecha',
            get_full_name: 'Empleado',
            sales_comission_pct: 'Comisión actual (%)',
            pending_comissions_total_amt: 'Generado pendiente de cobro',
            actions: 'Acciones',
          },
        },
      },
      languageCodes: store.getLanguageCodes().filter((x) => x == 'es'),
      languageNames: store.getLanguageNames(),
      cashDetails: null,
      locationInfo: null,
    };
  },
  computed: {
    pendingAmt() {
      return (
        this.totalPrice -
        parseFloat(this.form.amtPaidCredit ? this.form.amtPaidCredit : '0.00') -
        parseFloat(
          this.form.amtPaidTransfer ? this.form.amtPaidTransfer : '0.00'
        ) -
        parseFloat(this.form.amtPaidCash ? this.form.amtPaidCash : '0.00')
      );
    },
    totalPrice() {
      return (
        parseFloat(this.form.totalPriceProductsInclTax) -
        parseFloat(this.form.discount) +
        parseFloat(this.form.shippingPrice)
      );
    },
  },

  created() {
    // this.productsMultiselect.isLoading = true;

    this.getCash();

    this.$watch(
      () => this.$route.params,
      (toParams, previousParams) => {
        this.table.url = uris.cashByLocationURI(this.location);
        this.tableComissions.url = uris.cashPendingSalesComissionByLocationURI(
          this.location
        );
        this.getCash();
        // this.$refs.table.refresh();
      }
    );
  },
  filters: {
    formatStockProductDetails: function (stockLineData) {
      if (stockLineData.product) {
        // Product
        return stockLineData.product.reference;
      } else if (stockLineData.predefined_product) {
        // Predefined
        return stockLineData.predefined_product.reference;
      } else {
        return `${stockLineData.product_attributes.reference} ${
          stockLineData.product_attributes.description
            ? `(${stockLineData.product_attributes.description})`
            : ''
        } `;
        // Free text
      }
    },
    formatBillingAddress: function (billingAddress) {
      const {
        first_name,
        last_name,
        street_address,
        postal_code,
        city,
        country,
        company_name,
        company_id,
      } = billingAddress;

      let lines = [];
      lines.push(`${first_name} ${last_name}`);
      lines.push(`${street_address}`);
      lines.push(`${city} (${postal_code})`);
      lines.push(`${country}`);

      return lines;
    },
  },
  methods: {
    processNewOutgoingPayment(modalData) {
      modalData['location_id'] = this.location;

      actions
        .postCashNewOutgoingPayment(modalData)
        .then((x) => {
          this.getCash();
          this.$refs.table.refresh();
          this.showOutgoingPaymentModal = false;
        })
        .catch((err) => {
          if (
            err.response.status == 400 &&
            err.response.data === 'ERROR_INVALID_AMT'
          ) {
            alert('La cantidad no puede ser igual o menor a 0');
          }

          if (
            err.response.status == 400 &&
            err.response.data === 'ERROR_EMPTY_DESCRIPTION'
          ) {
            alert('Hay que especificar un concepto');
          }

          if (
            err.response.status == 400 &&
            err.response.data === 'ERROR_INSUFFICIENT_FUNDS'
          ) {
            alert('No hay suficiente dinero en la caja');
          }
        });
    },
    getCash() {
      let promises = [];
      promises.push(actions.getCash(this.location));
      promises.push(actions.getLocationById(this.location));

      Promise.all(promises).then((x) => {
        this.cashDetails = x[0].data;
        this.locationInfo = x[1].data;
      });
    },
    enoughCashToPay(pendingComissionAmt, cashQuantity) {
      return parseFloat(cashQuantity) >= parseFloat(pendingComissionAmt);
    },
    redeemComission(locationId, employeeId) {
      actions
        .postCashRedeemComission({
          location_id: locationId,
          employee_id: employeeId,
        })
        .then((x) => {
          this.$refs.table.refresh();
          this.$refs.tableComissions.refresh();
          actions.getLocationById(this.location).then((x) => {
            this.locationInfo = x.data;
          });
        })
        .catch((y) => {
          alert('Error');
        });
    },
    payWithCredit() {
      this.form.amtPaidCredit = this.totalPrice.toFixed(2);
      this.form.amtPaidTransfer = '0.0';
      this.form.amtPaidCash = '0.0';
    },
    payWithTransfer() {
      this.form.amtPaidTransfer = this.totalPrice.toFixed(2);
      this.form.amtPaidCredit = '0.0';
      this.form.amtPaidCash = '0.0';
    },
    payWithCash() {
      this.form.amtPaidCash = this.totalPrice.toFixed(2);
      this.form.amtPaidCredit = '0.0';
      this.form.amtPaidTransfer = '0.0';
    },
    isStockAvailable(i) {
      let availableStock = this.form.productStocks[i][this.location];
      let productQuantity = this.form.products[i].quantity;

      return availableStock >= productQuantity;
    },

    changeProductDiscount(i, val) {
      val = val.replace('.', ''); // remove thousands
      val = val.replace(',', '.'); // replace comma by dot
      this.form.productDiscounts[i] = val;

      this.quotePrice();
    },
    swapProducts(i, j) {
      this.form.products[i] = this.form.products.splice(
        j,
        1,
        this.form.products[i]
      )[0];
      this.form.productPricesInclTax[i] = this.form.productPricesInclTax.splice(
        j,
        1,
        this.form.productPricesInclTax[i]
      )[0];
      this.form.productPricesExclTax[i] = this.form.productPricesExclTax.splice(
        j,
        1,
        this.form.productPricesExclTax[i]
      )[0];

      this.form.productHashes[i] = this.form.productHashes.splice(
        j,
        1,
        this.form.productHashes[i]
      )[0];

      this.form.productStocks[i] = this.form.productStocks.splice(
        j,
        1,
        this.form.productStocks[i]
      )[0];

      if (this.form.discountType === 'Per-product') {
        this.form.productDiscounts[i] = this.form.productDiscounts.splice(
          j,
          1,
          this.form.productDiscounts[i]
        )[0];

        this.form.productDiscountsAbsolute[
          i
        ] = this.form.productDiscountsAbsolute.splice(
          j,
          1,
          this.form.productDiscountsAbsolute[i]
        )[0];
      }
    },
    moveUp(i) {
      i = parseInt(i);
      this.swapProducts(i, i - 1);
    },
    moveDown(i) {
      i = parseInt(i);
      this.swapProducts(i, i + 1);
    },
    orderedProductImagesArr(productImages) {
      let arr = [];
      for (let index = 0; index < Object.keys(productImages).length; index++) {
        const element = Object.keys(productImages).reverse()[index];
        arr.push(productImages[element].$model);
      }
      return arr;
    },

    setDecimal(name, val) {
      val = val.replace('.', ''); // remove thousands
      val = val.replace(',', '.'); // replace comma by dot
      this.$v.form[name].$model = val;
      this.$v.form[name].$touch();
    },
    setDecimalProduct(i, name, val) {
      val = val.replace('.', ''); // remove thousands
      val = val.replace(',', '.'); // replace comma by dot
      this.$v.form.products.$each.$iter[i][name].$model = val;
      this.$v.form.products.$each.$iter[i][name].$touch();
      this.quotePrice();
    },
    customerAdded(idCustomer) {
      actions.getCustomersUnpaginated().then((response) => {
        this.customersMultiselect.loadedOptions = response.data.results.map(
          (x) => {
            return {
              text:
                x.last_name +
                ' ' +
                x.first_name +
                (x.email ? ' (' + x.email + ')' : ''),
              value: x.id,
            };
          }
        );

        this.customersMultiselect.isLoading = false;
        this.form.customer = this.customersMultiselect.loadedOptions.find(
          (x) => x.value === idCustomer
        );
        this.showNewCustomerModal = false;
      });
    },
    newCustomerModal() {
      this.showNewCustomerModal = true;
    },

    changedDiscount() {
      if (!this.form.shippingMethod) {
        return false;
      }
      this.quotePrice(false /*, true*/);
    },
    quotePrice(
      onlyUpdateShippingPrice = false /*, onlyUpdateDiscount = false*/
    ) {
      let data = {};

      data['customer'] = this.form.customer.value;
      data['billing_address'] = this.form.billingAddress;
      data['shipping_address'] = this.form.shippingAddress;

      data['shipping_method'] = this.form.shippingMethod;
      data['products'] = this.form.products;

      data['discount_pct'] = this.form.discountPct;

      data['product_discounts'] = this.form.productDiscounts;

      actions.postQuotePrice(data).then((x) => {
        // if (onlyUpdateDiscount) {
        //   this.form.discount = x.data.discount;
        //   this.form.taxPrice = x.data.taxPrice;
        // } else
        if (!onlyUpdateShippingPrice) {
          this.form.productPricesInclTax = x.data.productPricesInclTax;
          this.form.productPricesExclTax = x.data.productPricesExclTax;
          this.form.productDiscountsAbsolute = x.data.productDiscountsAbsolute;

          this.form.discount = x.data.discount;

          this.form.totalPriceProductsInclTax =
            x.data.totalPriceProductsInclTax;

          this.form.totalPriceProductsExclTax =
            x.data.totalPriceProductsExclTax;

          this.form.taxPrice = x.data.taxPrice;

          this.form.productHashes = x.data.productHashes;
          this.form.productStocks = x.data.productStockAvailability;

          if (this.$v.form.shippingMethod.$model !== 6) {
            this.form.shippingPrice = x.data.shippingPrice.toFixed(2);
          }
        } else {
          if (this.$v.form.shippingMethod.$model !== 6) {
            this.form.shippingPrice = x.data.shippingPrice.toFixed(2);
          }
        }
      });
    },
    cancelAddProduct() {
      this.showModal = false;
    },
    editSubtitle(subtitle) {
      const editedArticleIndex = this.articleCurrentIndex;

      this.form.products.splice(editedArticleIndex, 1, {
        subtitle: subtitle,
        type: 'subtitle',
      });

      this.showSubtitleModal = false;
    },

    addSubtitle(subtitle) {
      this.showSubtitleModal = false;

      this.form.products.push({
        subtitle: subtitle,
        type: 'subtitle',
      });

      // this.form.discountPct = this.form.customer.default_discount;

      this.quotePrice();
    },

    deleteArticle(articleIndex) {
      const name = this.form.products[articleIndex].reference;

      if (
        confirm(
          '¿Estás seguro que deseas quitar el producto ' +
            name +
            ' del presupuesto?'
        )
      ) {
        this.form.products.splice(articleIndex, 1);
        this.quotePrice();
      }
    },
    editArticle(articleIndex) {
      //if ()
      this.selectedProductID = this.form.products[articleIndex].id.toString();

      if (this.form.products[articleIndex].type === 'predefined') {
        this.selectedProductID = 'PRE_' + this.selectedProductID;
      }

      this.selectedProductData = this.form.products[articleIndex];
      this.articleCurrentIndex = articleIndex;

      if (this.selectedProductID === '0') {
        this.showFreeArticleModal = true;
      } else {
        this.showModal = true;
      }
    },
    duplicateArticle(articleIndex) {
      const newProduct = JSON.parse(
        JSON.stringify(this.form.products[articleIndex])
      );

      this.form.products.splice(articleIndex, 0, newProduct);

      this.form.productPricesInclTax.splice(
        articleIndex,
        0,
        this.form.productPricesInclTax[articleIndex]
      );

      this.form.productPricesExclTax.splice(
        articleIndex,
        0,
        this.form.productPricesExclTax[articleIndex]
      );

      this.quotePrice();
    },
    addFreeTextArticleToQuoteBtn() {
      this.selectedProductID = null;
      this.selectedProductData = null;

      this.showFreeArticleModal = true;
    },
    addSubtitleToQuoteBtn() {
      this.selectedProductID = null;
      this.selectedProductData = null;

      this.showSubtitleModal = true;
    },
    addArticleToQuoteBtn() {
      this.selectedProductID = this.form.product.value.toString();

      this.selectedProductData = null;

      this.showModal = true;
    },
    discountTypeChanged(val) {
      if (val === 'Per-product') {
        let arr = [];
        for (let index = 0; index < this.form.products.length; index++) {
          arr.push('0');
        }

        this.form.productDiscounts = arr;
        this.form.productDiscountsAbsolute = arr;

        this.form.discountPct = '0';
        this.form.discount = 0;
      } else {
        this.form.discountPct = '0';
        this.form.discount = 0;
      }
    },
    shippingMethodChanged(val) {
      if (![3, 4, 5, 6, 7].includes(this.$v.form.shippingMethod.$model)) {
        this.$v.form.shippingAddress.$model = null;
      } else if (
        [3, 4, 5, 6, 7].includes(this.$v.form.shippingMethod.$model) &&
        this.form.shippingAddress === null &&
        this.shippingAddressSelect.loadedOptions.length > 0
      ) {
        this.$v.form.shippingAddress.$model = this.shippingAddressSelect.loadedOptions[0].value;
      }

      this.quotePrice(true);
    },
    billingAddressSelectChanged(val) {
      actions.getBillingAddress(val).then((z) => {
        this.billingAddressSelect.selectedAddress = z.data;
      });
    },
    customersMultiselectChanged(selectedOption, id) {
      this.setDecimal(
        'discountPct',
        selectedOption.default_discount.replace('.', ',')
      );
      this.changedDiscount();

      actions.getBillingAddressesByCustomer(selectedOption.value).then((y) => {
        this.billingAddressSelect.loadedOptions = y.data.results.map((x) => {
          return {
            text: x.name,
            value: x.id,
          };
        });
      });

      actions.getShippingAddressesByCustomer(selectedOption.value).then((y) => {
        this.shippingAddressSelect.loadedOptions = y.data.results.map((x) => {
          return {
            text: x.name,
            value: x.id,
          };
        });
      });
    },
    asyncFindCustomers(query) {
      this.customersMultiselect.isLoading = true;
      actions.getCustomersGlobalSearch(query).then((response) => {
        this.customersMultiselect.loadedOptions = response.data.results.map(
          (x) => {
            return {
              text:
                x.last_name +
                ' ' +
                x.first_name +
                (x.email ? ' (' + x.email + ')' : ''),
              value: x.id,
              default_discount: x.default_discount,
            };
          }
        );
        this.customersMultiselect.isLoading = false;
      });
    },

    asyncFindProducts(query) {
      this.productsMultiselect.isLoading = true;

      let promises = [];
      promises.push(actions.getProductsGlobalSearch(query));
      promises.push(actions.getPredefinedProductsGlobalSearch(query));

      Promise.all(promises).then((response) => {
        let arr = [];

        arr = [
          ...arr,
          ...response[0].data.results.map((x) => {
            return {
              text: '(' + x.id + ') ' + x.reference,
              value: x.id,
            };
            // eslint-disable-next-line prettier/prettier
          }),
        ];

        arr = [
          ...arr,
          ...response[1].data.results.map((x) => {
            return {
              text: '(' + x.id + ') ' + x.reference,
              value: 'PRE_' + x.id,
            };
            // eslint-disable-next-line prettier/prettier
          }),
        ];

        this.productsMultiselect.loadedOptions = arr;

        this.productsMultiselect.isLoading = false;
      });
    },

    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    validateStateProduct(index, field) {
      const { $dirty, $error } = this.$v.form.products.$each[index][field];
      return $dirty ? !$error : null;
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.subtitle {
  background-color: #f3f3f3;
  border: lightgray 1px solid;
  border-radius: 0.25rem;
  padding: 0.5rem;
  text-align: center;
}
.uniqueImg {
  display: block;
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
}
.leftImg {
  display: block;
  max-width: 80%;
  max-height: 80%;
  width: auto;
  height: auto;
  position: absolute;
  top: 0;
  left: 0;
}
.rightImg {
  display: block;
  max-width: 80%;
  max-height: 80%;
  width: auto;
  height: auto;
  position: absolute;
  top: 2rem;
  left: 2rem;
}

.comments {
  margin-top: 0.2rem;
  font-style: italic;
}

.gray-text {
  display: block;
  color: gray;
}

.stock {
  white-space: pre-wrap;
  &.available {
    color: green;
  }
  &.unavailable {
    color: red;
  }
}

ol {
  list-style-type: circle;
  li {
    margin-left: 2rem;
  }
}
</style>
